// src/authConfig.js
import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '64bb705c-edf7-4233-b750-7e886544281b',
    authority: 'https://artbiotx.ciamlogin.com/',
    redirectUri: '/', 
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [],
};
